import shortid from "shortid";
import {
  Checkbox,
  Menu,
  MenuItem
} from "../../../components";
import palette from "../../../styles/dark-theme/palette";

const FiltroAgendamentoMenu = ({
  anchorEl,
  setAnchorEl,
  filtros,
  setFiltros,
  prestadorServicoList,
  dataSelecionada,
  mesSelecionado,
  formatFilterDate,
  buscarAgendamentos,
  buscarAgendamentosMes
}) => {
  const isMenuOpen = Boolean(anchorEl);
  const menuId = "agendamentos-filtros-menu";

  const handleClose = () => {
    setAnchorEl(null);
  };

  const resetFiltros = (porIntervalo) => {
    delete filtros.prestadorServicoId;
    buscarAgendamentos({ porIntervalo });
    buscarAgendamentosMes({ mesReferencia: mesSelecionado });
  }

  const filtrarAgendamentos = (porIntervalo, prestadorServicoId) => {
    setFiltros((prevState) => ({
      ...prevState,
      prestadorServicoId
    }));
    buscarAgendamentos({ 
      porIntervalo, 
      prestadorServicoId
    });
    buscarAgendamentosMes({
      mesReferencia: mesSelecionado, 
      prestadorServicoId
    });
  }

  const handlePrestadorChecked = (id) => {
    const porIntervalo = formatFilterDate(dataSelecionada);
    
    const prestador = filtros?.prestadorServicoId?.find((item) => item === id);
    let listPrestadores = null;
    if (prestador) {
      listPrestadores = filtros?.prestadorServicoId?.filter((item) => item !== id);
      if (listPrestadores?.length === 0) {
        resetFiltros(porIntervalo);
        return;
      }    
    } else {
      listPrestadores = [
        ...(filtros?.prestadorServicoId || []),
        id
      ];
    }

    filtrarAgendamentos(porIntervalo, listPrestadores);
  }

  const handleSelecionarTodos = () => {
    const porIntervalo = formatFilterDate(dataSelecionada);

    const checked = filtros?.prestadorServicoId?.length === prestadorServicoList?.length;
    if (checked) {
      resetFiltros(porIntervalo);
    } else {
      const prestadoresId = prestadorServicoList.map(({id}) => id);
      filtrarAgendamentos(porIntervalo, prestadoresId);
    }
  }

  return (
    <Menu
      className="my-1"
      anchorEl={anchorEl}
      elevation={1}
      getContentAnchorEl={null}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      id={menuId}
      autoFocus={false}
      open={isMenuOpen}
      onClose={handleClose}
      slotProps={{ 
        paper: { 
          sx: { 
            overflow: 'visible', 
            borderTopLeftRadius: 0, 
            '&::before': { 
              content: '""', 
              position: 'absolute', 
              top: 5, left: 2, 
              width: 10, height: 10, 
              bgcolor: 'background.paper', 
              transform: 'translateY(-100%) rotate(45deg)', 
            }, 
          }, 
        },
      }}
    >
      <MenuItem
        key={shortid.generate()}
        className="py-0"
        onClick={handleSelecionarTodos}
        sx={{ 
          paddingLeft: "0px", 
          paddingRight: "12px",
          '&:hover': { 
            '&::before': { 
              content: '""', 
              position: 'absolute', left: 0, top: 0, bottom: 0, 
              width: '2px',
              backgroundColor: palette.primary.main, 
            },
          }
        }}
      >
        <Checkbox
          checked={
            filtros?.prestadorServicoId?.length === prestadorServicoList?.length
          }
          color="primary"
          name="prestadorServico"
        />
        TODOS
      </MenuItem>
      {prestadorServicoList.map((prestador) =>
        <MenuItem
          key={prestador.id}
          className="py-0"
          onClick={() => handlePrestadorChecked(prestador.id)}
          sx={{ 
            paddingLeft: "0px", 
            paddingRight: "12px",
            '&:hover': { 
              '&::before': { 
                content: '""', 
                position: 'absolute', left: 0, top: 0, bottom: 0, 
                width: '2px',
                backgroundColor: palette.primary.main, 
              },
            }
          }}
        >
          <Checkbox
            key={prestador.id}
            checked={
              !!filtros?.prestadorServicoId?.find((id) => prestador.id === id)
            }
            color="primary"
            name="prestadorServico"
          />
          {prestador.nomeRazaoSocial}
        </MenuItem>
      )}
    </Menu>
  );
};

export default FiltroAgendamentoMenu;
